export default __webpack_public_path__ + "static/media/new-sparck.67711c70.png";